// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2gLjD","header":"ReportDetails_header__agd8M","title":"ReportDetails_title__25BMt","left":"ReportDetails_left__f2GWF"};